import t from"react";import e from"@mui/material/InputAdornment";import{CloseIcon as r}from"./styles.js";const m=()=>t.createElement(e,{position:"end"},t.createElement(r,null));export{m as ErrorAdornment};
//# sourceMappingURL=ErrorAdornment.js.map
